import { schema, normalize } from 'normalizr';
import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'gateway';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'gatewayID',
  }
);
export const normalizer = result => normalize(result, entitySchema);
export const listNormalizer = result => normalize(result, [entitySchema]);

// Gateway Transformers
export const { transformer, listTransformer } = createRetailTransformers('gateway');
